function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M37.455 48.364c-3.122-6.198-2.806-17.236-2.545-21.512 4.936-.339 8.487-1.274 8.487-2.376 0-1.081-3.418-2.003-8.211-2.356a9.498 9.498 0 005.156-8.45 9.5 9.5 0 00-9.5-9.5 9.5 9.5 0 00-9.5 9.5 9.497 9.497 0 005.156 8.45c-4.793.353-8.212 1.275-8.212 2.356 0 1.102 3.552 2.037 8.488 2.376.262 4.276.577 15.314-2.545 21.512-6.117 1.23-10.41 4.116-10.41 7.48h34.045c0-3.364-4.287-6.252-10.405-7.484z",
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 0.9247071,
  strokeLinejoin: "round"
});

function SvgWhitePawn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _ref);
}

export default SvgWhitePawn;